import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
// import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../shared/Fetch";
// import { Filter } from "../Filter";
// import { Publish } from "../Publish";
// import { IAllRequirements } from "../../../models/AllRequirements";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
// import { IReqFilter, EmptyFilter } from "../Filter";
import { Tag } from 'primereact/tag';
// import { SubmissionsTable } from "./SubmissionsTable";
// import { POReport } from "./POReport";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IAllRequirements } from "../../models/AllRequirements";
import { EmptyFilter, Filter, IReqFilter } from "./Filter";
import { Toast } from "primereact/toast";
import { Publish } from "../requirement/Publish";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { User } from "../jvConnect/User";
import { Job_Type, Publish_Type, Req_Term } from "../../models/RequirementMast";

interface Iprops {
    toast?: any,
    reload?: boolean,
    setReload?: (is: boolean) => void,
    permissions?: IPermissionProps
}

export interface IModel2 {
    open: boolean,
    singleData: IAllRequirements
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const [loading, setLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    const [poDetails, setPODetails] = useState({ vendor_Company_ID: 0, open: false } as { vendor_Company_ID: number, open: boolean });
    const hidePODetailsDialog = () => {
        setPODetails({ vendor_Company_ID: 0, open: false });
    };
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean, rrreason: string | undefined, req_ID: number | undefined });
    const hideRRRDialog = () => {
        setRRR({ open: false, rrreason: "", req_ID: 0 });
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Float", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${3}`, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setTableData({
                tableData: data.map((rowData: any) => {
                    if (rowData.recruiter)
                        return { ...rowData, recruiter: (rowData.recruiter).split(',').map((ele: string) => (ele.trim().split("-")[0] + '-' + ele.trim().split("-")[1])).join(", ") }
                    else return rowData;
                }), loading: false
            });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            // props.permissions.is_Export ?
            1 ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Float Requirements</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                    {/* <div onClick={() => setReqFilter((f) => { return { ...f, served_status: null } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'DodgerBlue', color: 'white' }}>All</div> */}
                    {/* <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "UnAllocated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'skyblue', color: 'white' }}>UnAlloc</div> */}
                    {/* <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Served" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'green', color: 'white' }}>Served</div> */}
                    {/* <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Unserved" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'yellow', color: 'black' }}>UnServed</div> */}
                    {/* <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Rejected" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'red', color: 'white' }}>Rejected</div> */}
                    {/* <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Updated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>Updated</div> */}
                    {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
                </div>
            </span>
        </div>
    );

    const req_Job_Title = (rowData: IAllRequirements) => {
        return rowData.rejected_Status === "Yes" ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
                setRRR({ open: true, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID })
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="warning" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };
    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const [subTable, setSubTable] = useState({ req_id: 0, job_Title: "", open: false } as { req_id: number, job_Title?: string, open: boolean });
    const hideSubTable = () => {
        setSubTable({ req_id: 0, job_Title: "", open: false });
    };

    const submission_id = (rowData: IAllRequirements) => {
        const arOfCons = rowData.submission_id?.split(',');
        const arOfConsId: number[] = [];
        const arOfSubm = rowData.submission_status?.split(',');
        const subm: { [key: string]: number } = {};
        const key: string[] = [];
        arOfCons?.forEach(c => {
            arOfConsId.push(parseInt(c.split('-')[0]));
            key.push(c.split('-')[0].trim());
        });
        arOfSubm?.forEach(s => {
            const temp = s.split('-');
            subm[temp[0].trim()] = parseInt(temp[1]);
        });
        let is_Pending = 0;
        if (arOfCons) {
            for (let index = 0; index < arOfCons.length; index++) {
                if (subm[key[index]] === undefined) {
                    is_Pending++;
                };
            }
        }

        const countOfSubmissions = rowData.submission_id?.split(', ').length;
        const color = countOfSubmissions ? '#b30000' : rowData.recruiter ? 'yellow' : 'skyblue';

        return rowData.is_Update_Status === 1 ?
            // (props.permissions.is_Create ?
            (1 ?
                <div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
                    <span className="cursor-pointer text-white underline">
                        {rowData.submission_id}</span></div> :
                <div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
                    <span className="text-white">{rowData.submission_id}</span></div>
            ) : (
                <div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
                    <span className="text-white">{rowData.submission_id}</span></div>
            );
    };

    const sendFloatEmail = async (req_ID: number) => {
        const response = await Fetch("Float/sendEmailForNoSubmissionsYet", "GET", null, `req_id=${req_ID}`, props.toast);
        if (response) {
            const resp: string = await response.text();
            props.toast.current.show({ severity: 'success', summary: 'success', detail: resp, life: 3000 });
            setLoading(false);
            loadTableData();
        } else {
            setLoading(false);
        }
    }

    const noofPO = (rowData: IAllRequirements) => {
        return <span className="text-cyan-700 underline">{rowData.noofPO}</span>;
    };

    const floatButton = (rowData: IAllRequirements) => {
        if (rowData.hold) {
            return <div style={{ display: 'grid', marginTop: '5px' }}>
                {(rowData.publish_Type !== Publish_Type.Globally ? ' Float' : 'Floated')}
            </div>;
        }

        // let vizonFloat = false;
        // let adventaFloat = false;
        // let gvrFloat = false;
        // let jobvrittaFloat=false;

        // const postedDate = new Date(new Date(rowData.pDate || "").setMinutes(new Date(rowData.pDate || "").getMinutes() + 45));
        // const postedDate1 = new Date(new Date(rowData.pDate || "").setMinutes(new Date(rowData.pDate || "").getMinutes() + 0));

        // const current = new Date();
        // if (rowData.company_ID === 7 && postedDate <= current && rowData.is_Float_Global === false) {
        //     vizonFloat = true;
        // }
        // if (rowData.company_ID === 4 && postedDate <= current && rowData.is_Float_Global === false) {
        //     adventaFloat = true;
        // }
        // if (rowData.company_ID === 3 && postedDate <= current && rowData.is_Float_Global === false) {
        //     gvrFloat = true;
        // }
        // if (rowData.company_ID === 8 && postedDate1 <= current && rowData.is_Float_Global === false) {
        //     jobvrittaFloat = true;
        // }

        // if (vizonFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (vizonFloat === true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}
        //     // </div>);
        // } else if (adventaFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (adventaFloat == true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}

        //     // </div>);
        // } else if (gvrFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (gvrFloat == true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}

        //     // </div>);
        // }
        // else if (jobvrittaFloat === true) {
        //     return <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button>;
        //     // return (gvrFloat == true ? <Button loading={loading} className="p-button my-1 bg-blue-500 w-5" label={((rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : <div style={{ display: 'grid', marginTop: '5px' }}>
        //     //     {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}

        //     // </div>);
        // }
        //  else {
        return rowData.publish_Type !== Publish_Type.Globally ?
            <Button loading={loading} className="p-button my-1 bg-blue-500" label='Float'
                onClick={async () => {
                    if (rowData.req_ID) {
                        setLoading(true);
                        await sendFloatEmail(rowData.req_ID);
                    }
                }} type="button" />
            : "Floated";
        // };

        // return (
        //     <div style={{ display: 'grid', marginTop: '5px' }}>
        //         {rowData.company_ID === 4 && !adventaFloat? (
        //             <div style={{ display: 'grid', marginTop: '5px' }}>
        //                 {rowData.is_Float_Global === null || rowData.is_Float_Global === false ? (
        //                     <Button loading={loading} className="p-button my-1 bg-blue-500" label={rowData.is_Float_Company === null || rowData.is_Float_Company === false ? 'Float' : 'Floated'} onClick={() => { if (rowData.req_ID != null && rowData.req_ID !== 0) { sendFloatEmail(rowData.req_ID); } setLoading(true); }} type="button" />
        //                 ) : (
        //                     "Floated"
        //                 )}
        //             </div>
        //         ) :
        //          ( 
        //             vizonFloat || adventaFloat || gvrFloat? <Button loading={loading} className="p-button my-1 bg-blue-500"
        //             label='Float' onClick={() => { if (rowData.req_ID != null && rowData.req_ID != 0) { sendFloatEmail(rowData.req_ID); } setLoading(true); }} type="button" /> : (
        //             rowData.is_Float_Global === null || rowData.is_Float_Global === false ? (
        //                 <Button loading={loading} className="p-button my-1 bg-blue-500"
        //                     label='Float' onClick={() => { if (rowData.req_ID != null && rowData.req_ID != 0) { sendFloatEmail(rowData.req_ID); } setLoading(true); }} type="button" />
        //             ) : (
        //                 "Floated"))
        //             ) 
        //                 }
        //     </div>
        // );


        // return (<div style={{ display: 'grid', marginTop: '5px' }}>
        //     {rowData.company_ID == 4 ? (<div style={{ display: 'grid', marginTop: '5px' }}>
        //         {(rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? <Button loading={loading} className="p-button my-1 bg-blue-500" label={(rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? 'Comp + Global Float' : 'Floated'} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button"></Button> : "Floated"}
        //     </div>) :

        {/* ((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ?
                <Button loading={loading} className="p-button my-1 bg-blue-500"
                    label={(rowData.is_Float_Company === null || rowData.is_Float_Company === false) ? 'Within Comp' : ((rowData.is_Float_Global === null || rowData.is_Float_Global === false) ? ' Global Float' : 'Floated')} onClick={() => { if ((rowData.req_ID != null || rowData.req_ID != 0)) { sendFloatEmail(rowData.req_ID || 0); } setLoading(true); }} type="button">

                </Button> : "Floated")} */}
        // </div>);
    }

    const DateFormat = loginObj.date_Format;

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={4} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable />
                <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_CategoryName" header="Category" sortable />
                <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
                <Column field="pDate" header="Posted On" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IAllRequirements) => <User req={{
                        reqId: r.req_ID ?? '',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }}
                    />} />
                <Column field="recruiter" header="Recruiter" />
                <Column field="submission_id" header="Submittals" body={submission_id} />
                <Column field="req_EndClient" sortable header="End Client" />
                <Column field="client_Communication" sortable header="Client Communication" />
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="client" sortable header="Client" />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="contact_Person_Name" header="Contact Person" />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="noofPO" sortable header="#PO" body={noofPO} />}
                <Column field="hold" header="Status" body={(rowData: IAllRequirements) => rowData.hold ? "Hold" : "Unhold"} />
                <Column field="Float" body={floatButton} style={{ minWidth: '6rem' }} />
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={4} /> */}
            {/* <SubmissionsTable req_id={subTable.req_id} job_Title={subTable.job_Title} open={subTable.open} hideDialog={hideSubTable} toast={props.toast} reload={props.reload} setReload={props.setReload} /> */}
            {/* <POReport open={poDetails.open} vendor_Company_ID={poDetails.vendor_Company_ID} hideDialog={hidePODetailsDialog} toast={props.toast} /> */}
            <Dialog visible={rrr.open} style={{ width: '80vw' }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
                <JVSunEditor value={rrr.rrreason} />
            </Dialog>
        </>
    );
}
